// extracted by mini-css-extract-plugin
module.exports = {"has-border-radius":"Post_has-border-radius__fnYtE","post-button":"Post_post-button__6loDR"};